import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Chat from "@/pages/Chat";
import Browse from "@/pages/Browse";
import Share from "@/pages/Share";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import AffiliateDisclosure from "@/pages/AffiliateDisclosure";
import AIDisclaimer from "@/pages/AIDisclaimer";
import Contact from "@/pages/Contact";
import BuyingAdvice from "@/pages/BuyingAdvice";
import BuyingAdviceArticle from "@/pages/BuyingAdviceArticle";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminQA from "@/pages/AdminQA";
import AdminReviewQueue from "@/pages/AdminReviewQueue";
import AdminAffiliate from "@/pages/AdminAffiliate";
import { applyTheme, getInitialTheme } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";

function App() {
  useEffect(() => {
    applyTheme(getInitialTheme());
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/browse/:slug" element={<Browse />} />
          <Route path="/r/:id" element={<Share />} />
          {/* Legal / compliance pages */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
          <Route path="/ai-disclaimer" element={<AIDisclaimer />} />
          <Route path="/contact" element={<Contact />} />
          {/* Buying Advice — the editorial knowledge centre */}
          <Route path="/buying-advice" element={<BuyingAdvice />} />
          <Route path="/buying-advice/:slug" element={<BuyingAdviceArticle />} />
          {/* Admin */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/qa" element={<AdminQA />} />
          <Route path="/admin/queue" element={<AdminReviewQueue />} />
          <Route path="/admin/affiliate" element={<AdminAffiliate />} />
        </Routes>
        <Toaster position="top-right" />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
